module.exports = __webpack_public_path__ + "img/1.9f14ab4c.jpg";